module.exports = __webpack_public_path__ + "static/img/user2.614d5b2e.png";